var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSpaceEnded = function SvgSpaceEnded(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14.35V37.2145C0.5 38.6502 2.21425 39.3929 3.26166 38.4109L11.1047 31.0581C11.3158 30.8602 11.5944 30.75 11.8838 30.75H26.125C34.6164 30.75 41.5 23.8664 41.5 15.375C41.5 6.88362 34.6164 0 26.125 0H14.85C6.92471 0 0.5 6.42471 0.5 14.35Z",
    fill: "#8B5CF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14.35V37.2145C0.5 38.6502 2.21425 39.3929 3.26166 38.4109L11.1047 31.0581C11.3158 30.8602 11.5944 30.75 11.8838 30.75H26.125C34.6164 30.75 41.5 23.8664 41.5 15.375C41.5 6.88362 34.6164 0 26.125 0H14.85C6.92471 0 0.5 6.42471 0.5 14.35Z",
    fill: "url(#paint0_linear_15620_46454)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15620_46454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9805 13.1191V18.0391",
    stroke: "white",
    strokeWidth: 3.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5391 6.55859V24.5986",
    stroke: "white",
    strokeWidth: 3.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1016 9.83789L25.1016 21.3179",
    stroke: "white",
    strokeWidth: 3.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6602 13.1191L31.6602 18.0391",
    stroke: "white",
    strokeWidth: 3.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15620_46454",
    x1: 0.500001,
    y1: 41,
    x2: 43.42,
    y2: 38.8805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15620_46454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.08,
    height: 36.08,
    fill: "white",
    transform: "translate(2.96094)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceEnded);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA0MiA0MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNSAxNC4zNVYzNy4yMTQ1QzAuNSAzOC42NTAyIDIuMjE0MjUgMzkuMzkyOSAzLjI2MTY2IDM4LjQxMDlMMTEuMTA0NyAzMS4wNTgxQzExLjMxNTggMzAuODYwMiAxMS41OTQ0IDMwLjc1IDExLjg4MzggMzAuNzVIMjYuMTI1QzM0LjYxNjQgMzAuNzUgNDEuNSAyMy44NjY0IDQxLjUgMTUuMzc1QzQxLjUgNi44ODM2MiAzNC42MTY0IDAgMjYuMTI1IDBIMTQuODVDNi45MjQ3MSAwIDAuNSA2LjQyNDcxIDAuNSAxNC4zNVoiIGZpbGw9IiM4QjVDRjYiLz4KPHBhdGggZD0iTTAuNSAxNC4zNVYzNy4yMTQ1QzAuNSAzOC42NTAyIDIuMjE0MjUgMzkuMzkyOSAzLjI2MTY2IDM4LjQxMDlMMTEuMTA0NyAzMS4wNTgxQzExLjMxNTggMzAuODYwMiAxMS41OTQ0IDMwLjc1IDExLjg4MzggMzAuNzVIMjYuMTI1QzM0LjYxNjQgMzAuNzUgNDEuNSAyMy44NjY0IDQxLjUgMTUuMzc1QzQxLjUgNi44ODM2MiAzNC42MTY0IDAgMjYuMTI1IDBIMTQuODVDNi45MjQ3MSAwIDAuNSA2LjQyNDcxIDAuNSAxNC4zNVoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xNTYyMF80NjQ1NCkiLz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE1NjIwXzQ2NDU0KSI+CjxwYXRoIGQ9Ik0xMS45ODA1IDEzLjExOTFWMTguMDM5MSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzLjI4IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE4LjUzOTEgNi41NTg1OVYyNC41OTg2IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMuMjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjUuMTAxNiA5LjgzNzg5TDI1LjEwMTYgMjEuMzE3OSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzLjI4IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMxLjY2MDIgMTMuMTE5MUwzMS42NjAyIDE4LjAzOTEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMy4yOCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8xNTYyMF80NjQ1NCIgeDE9IjAuNTAwMDAxIiB5MT0iNDEiIHgyPSI0My40MiIgeTI9IjM4Ljg4MDUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjAwMDEiIHN0b3AtY29sb3I9IiNDMkMyQzIiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjQTNBM0EzIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTU2MjBfNDY0NTQiPgo8cmVjdCB3aWR0aD0iMzYuMDgiIGhlaWdodD0iMzYuMDgiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjk2MDk0KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";